import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-lot-moto-jupiter-inspection-card-slider',
  templateUrl: './lot-moto-jupiter-inspection-card-slider.component.html',
  styleUrls: ['./lot-moto-jupiter-inspection-card-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterInspectionCardSliderComponent implements OnChanges {
  @Input() images: string[];
  @Output() noImages = new EventEmitter<void>();

  swiperConfig: SwiperOptions = {
    loop: true,
    keyboard: false,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: true,
    pagination: true,
  };

  errorLoadImageCount = 0;

  imageLoadFailed(): void {
    this.errorLoadImageCount++;
    if (this.errorLoadImageCount === this.images.length) {
      this.noImages.emit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.images && !this.images.length) {
      this.noImages.emit();
    }
  }
}
